import {
  Box,
  Card,
  Grid,
  makeStyles,
  Typography,
  withStyles,
  useTheme,
  Fade,
  Theme,
  CircularProgress,
  Divider,
  ButtonGroup,
  FormControl,
  Select,
  MenuItem,
  InputLabel,
} from "@material-ui/core";

import {
  ArrowForward,
  ContactPhoneOutlined,
  Redo,
  ArrowBack,
} from "@material-ui/icons";
import Button from "@material-ui/core/Button";
import { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router";
import RequestCall from "./RequestCall";
import CloseIcon from "@material-ui/icons/Close";
import aimioLogo from "../../Images/aimio-logo.png";
import Tooltip from "@material-ui/core/Tooltip";
import coachesIcon from "../../Images/coachesIcon.svg";
import onboardIcon from "../../Images/onboardcoachicon.svg";
import externalIcon from "../../Images/externalpanel.svg";
import Footer from "../../Components/Footer/Footer";
import PhoneCallbackIcon from "@material-ui/icons/PhoneCallback";
import NavigateNextIcon from "@material-ui/icons/NavigateNext";
import NavigateBeforeIcon from "@material-ui/icons/NavigateBefore";
import ShotcutPopup from "./ShotcutPopup";
import icon1 from "../../Images/Icon13.svg";
import icon2 from "../../Images/Icon14.svg";
import icon3 from "../../Images/Icon3.svg";
import icon4 from "../../Images/Icon4.svg";
import icon5 from "../../Images/Icon5.svg";
import icon6 from "../../Images/Icon6.svg";
import icon7 from "../../Images/Icon7.svg";
import icon8 from "../../Images/Icon8.svg";
import icon9 from "../../Images/Icon9.svg";
import icon10 from "../../Images/Icon10.svg";
import icon11 from "../../Images/Icon11.svg";
import phoneIcon from "../../Images/phoneIcon.svg";
import getDirectData from "../../Service/get_direct_data_service";
import createData from "../../Service/create_data_service";
import { useDispatch, useSelector } from "react-redux";
import { showSnackbar } from "../../Components/Snackbar/SnackbarActions";
import ThanksPopup from "./ThanksPopup";
import OnboardCoachDetails from "./OnboardCoachDetails";
import { type } from "os";
import CustomSelect from "../../Components/CustomSelect";
import DataService from "../../Service";
import CopyToClipboard from "../Home/CopytoCipboard";
import Requestforassistance from "./Requestforassistance";

//import DocumentPdf from "../ResourcesDocuments/Aimio - Is coaching right for you.pdf
const ModalCard = (props: any) => {
  const classes = useStyles();
  return (
    <div className={classes.infoCard}>
      <p>{props.data}</p>
    </div>
  );
};

const LightTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: theme.palette.common.white,

    boxShadow: theme.shadows[1],
    fontSize: 14,
    color: "black",
    borderRadius: "11px",
    padding: "10px 26px 15px 26px",
  },
}))(Tooltip);

const COUNT_PER_PAGE = 6;
function Home() {
  const history = useHistory();
  const globalUserData = useSelector((state: any) => state.commonReducer);
  console.log("org idd", globalUserData.organisation_id);

  const orgId = globalUserData.organisation_id;

  const dispatch = useDispatch();

  const classes = useStyles();
  const [activeMenu, setActiveMenu] = useState(0);
  const [requestCallFlag, setRequestCallFlag] = useState(false);
  const [requestCoaches, setRequestCoaches] = useState(false);
  const [isThanksPopupOpen, setIsThanksPopupOpen] = useState(false);

  const [currentCardIndex, setCurrentCardIndex] = useState<number | null>(null);

  const [page, setPage] = useState(1);
  const [programes, setProgrames] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [busy, setBusy] = useState<any>(null);
  const [isShotcutPopupOpen, setIsShotcutPopupOpen] = useState(false);

  const [fieldsError, setFieldsError] = useState({});

  const [isLastPage, setIsLastPage] = useState(false);

  const [requestOnBoardCoaches, setRequestOnBoardCoaches] = useState(false);
  const [programRequest, setProgramRequest] = useState(false);
  const [requestforassistance, setRequestforassistance] = useState(false);

  const theme = useTheme();
  let { slug }: any = useParams();
  const orgName = globalUserData?.organisation_name ;
  const [crfExternalCoach, setCrfExternalCoach] = useState([]);
  const [crfInternalCoach, setCrfInternalCoach] = useState([]);
  const [crfSlug, setCrfSlug] = useState("");
  const orgCoachId = localStorage.getItem("organisation_id");
  const [loading, setLoading] = useState(false);
  const [crfInternalLoading, setCrfInternalLoading] = useState(false);

  const menues = [
    { menu: "Existing programs" },
    { menu: "New enquiries" },
    { menu: "Resources" },
    { menu: "Panels" },
    { menu: "Contact us" },
  ];

  const existProgramme = [
    {
      headingName: "Executive Coaching",
      info: "Our executive coaching program utilises coaching as a development tool to enhance leadership capability at all levels of the organization.",
      contentToBeShownOnHover: `Our executive coaching program utilises coaching as a development tool to enhance leadership capability at all levels of the organization. Coaching methodology and process are tailored to provide essential coaching services to the individual and also to produce measurable results that enhance leader effectiveness. The intended outcomes of coaching at Sky Corporation include one or more of the following: Develop top talent Keep valuable employees engaged Prepare leaders for new challenges and opportunities Provide ongoing development and support on identified competencies`,
      src: icon1,
    },
    {
      headingName: "Transition Coaching",
      info: "Our Transition Coaching provides a framework to facilitate transformative learning during senior leadership transitions.",
      contentToBeShownOnHover:
        "Our Transition Coaching provides a framework to facilitate transformative learning during senior leadership transitions. The value of transition coaching is to accelerate the process of transition by reducing the time needed to learn the new job, to build trust and credibility, and to speed up the time to delivering high performance. At the same time, it supports transitioning leaders’ development as they experience change and the challenges they will face.",
      src: icon2,
    },
    {
      headingName: "Internal Coaching",
      info: "One-on-one developmental intervention supported by the organisation and provided by our bank of internal coaches.",
      contentToBeShownOnHover:
        "One-on-one developmental intervention supported by the organisation and provided by our bank of internal coaches to support the professional development and growth of employees. Internal coaches understand the organisational culture and processes, and are used to support individuals who are at levels 4 and 5.",
      src: icon2,
    },
    {
      headingName: "Parental Leave Coaching",
      info: "This area of coaching is for parents-to-be prior to, during and after their parental leave.",
      contentToBeShownOnHover:
        "This area of coaching is for parents-to-be prior to, during and after their parental leave. Our parental leave coaches provide one-to-one support to work through the practical and emotional changes brought about by this significant life transition. For all individuals the coaching is intended to complement the parental support that the client already offers.",
      src: icon1,
    },
    {
      headingName: "Digital Disruption Coaching",
      info: "We have executives whose roles include digitally disrupting their own business divisions before the competition or in response to competitive threat.",
      contentToBeShownOnHover:
        "We have executives whose roles include digitally disrupting their own business divisions before the competition or in response to competitive threat. We use coaches who are experienced in this field either from having led a business through digital disruption or who have coached individuals to prosper in similar situations. These coaches can support our staff in achieving their own, and our, business objectives in this area.",
      src: icon2,
    },
    {
      headingName: "Coaching for Diversity",
      info: "Our Diversity and Inclusion coaching offering provides a one-to-one relationship that relies on transferring real world expertise.",
      contentToBeShownOnHover:
        "Our Diversity and Inclusion coaching offering provides a one-to-one relationship that relies on transferring real world expertise to strengthen our executives in this area for the benefit of the organisation. The focus ranges from 1:1 unconscious bias “coaching” through to organisational transformation coaching with all points in between.",
      src: icon2,
    },
  ];
  const resourceList = [
    {
      HeadingTitle: "Coaching needs assessment",
      src: icon3,
    },
    {
      HeadingTitle: "The benefits of coaching",
      src: icon7,
    },
    {
      HeadingTitle: "Executive coaching diagnostic checklist",
      src: icon8,
    },
    {
      HeadingTitle: "Is coaching right for you",
      src: icon9,
    },
    {
      HeadingTitle: " How to get the best from your coaching",
      src: icon2,
    },
  ];

  const coachPannel = [
    {
      headingtitle: "External panel",
      route: "CoachList",
      info: "This panel has been assembled to be utilized for most external coaching assignments.The panel consists of multiple external coaches who have been selected and briefed on Demo Client’s needs, preferences and strategic imperatives.Most of these coaches will have worked with Demo previously and will be personally familiar with the organisation.Clicking the view panel button below will enable you to search for coaching specialities, languages, locations and backgrounds to enable you to get a feel for the breadth and depth of the coach panel – identifying coaches that you think may be relevant for coachees, colleagues or even yourself.Once you have shortlisted coaches based on your criteria you can look at their profiles and download them to share with stakeholders.\n\n",
    },
    {
      headingtitle: "Internal panel",
      route: "InternalCoachList",
      info: "All Internal Coaches and Mentors who are accredited to be utilized internally as part of Demo Clients internal coaching and mentoring bench are accessible by clicking the button below.amio will enable you to search for coaching/mentoring specialities, languages, locations, and backgrounds to enable you to get a feel for the breadth and depth of the coach panel – identifying coaches that you think may be relevant for coachees, colleagues or even yourself.You will also be able to check their availability – including when they are free to start another engagement.In addition, stakeholders can check CPD and Supervision attendance to ensure internal coaches are compliant.Once you have shortlisted coaches based on your criteria you can look at their profiles and download them to share with stakeholders.",
    },
    {
      headingtitle: "Onboard coach request",
      route: "CoachList",
      // info:"We are able to onboard additional coaches where supported by the client and where there is a clear justification, for example:\n  1.Coachee worked with a particular coach previously\n  2.Coach has unusual levels of a particular capability \n\tthat is underrepresented in the panel \n 3.A senior sponsor recommends a particular coach \nSometimes there is a need for additional capability to be added to the panel where stakeholders don’t have a particular coach in mind.In these cases, aimio offers you scope to capture your needs and preferences or set up a call to discuss and identify alternative coaches from the wider pool that can deliver the required capability."
    },
  ];

  const handleClose = () => {
    setRequestCallFlag(false);
  };
  const handleOpen = () => {
    setRequestCallFlag(true);
  };

  useEffect(() => {
    const params = {
      page: page,
      count_per_page: COUNT_PER_PAGE,
      organisation_id: orgId,
    };
    setBusy("loading");
    getDirectData("/programmes", params)
      .then((res) => {
        console.log("api res",res);
        setProgrames(res.programmes);
        setTotalCount(res.total_count);
        setIsLastPage(
          Math.ceil(res.total_count / COUNT_PER_PAGE) === res.current_page
        );
        //service type---External
        //            let data = res?.programmes
        //           let coachExternalName = data.filter(
        //             (prg: any) => prg.service_type === "external"
        //           )
        //               setCrfExternalCoach(coachExternalName )
        //                    console.log("crf", crfExternalCoach)
        //                    //service type -- Internal
        //           let coachInternalName = data
        //             .filter((prg: any) => prg.service_type === "internal")
        //                   console.log("Internal", coachInternalName)
        //  setCrfInternalCoach(coachInternalName)
      })
      .catch((err) => {
        console.log("Something went wrong!");
      })
      .finally(() => setBusy(null));
  }, [page,orgId]);

  const validateFields = (formData: any) => {
    let valid = true;
    let error = {};

    for (let pair of formData.entries()) {
      const key = pair[0];
      const val = pair[1];

      if (!val || val.length < 3) {
        // @ts-ignore
        error[key] = true;
        valid = false;
      }
    }

    if (!valid) {
      setFieldsError(error);
    }

    return valid;
  };

  const requestCoachHandler = (event: any) => {
    const formData = new FormData(event.target);

    // validation
    if (!validateFields(formData)) return;

    setBusy("requesting");
    createData(formData, "requestCoaches")
      .then((res) => {
        if (res.success) {
          dispatch(showSnackbar("success", ["Success!"]));
          setIsThanksPopupOpen(true);
          setRequestCoaches(false);
          setRequestCallFlag(false);
          setRequestOnBoardCoaches(false);
          setRequestforassistance(false);
          setProgramRequest(false);
        }
      })
      .catch((err) => {
        if (!err.success) {
          dispatch(showSnackbar("error", ["Something went wrong!"]));
        }
      })
      .finally(() => setBusy(null));
  };

  //Internal and External Request Form

  const [items, setItems] = useState("");

  const handleInternalInputChange = (event: any) => {
    setItems(event.target.value);

    const paramsid = {
      programme_id: event.target.value,
    };
    console.log("Clicked");
    DataService.getDirectData(`/coaching_request_forms`, paramsid)
      .then((res) => {
        if (res.success) {
          console.log(res, "response");
          setCrfInternalLoading(true);
          window.sessionStorage.setItem("slug", res.coaching_request_form.slug);
          let slug = res.coaching_request_form.slug;
          setCrfSlug(slug);
        }
      })
      .catch((err) => {
        if (!err.success) {
          dispatch(showSnackbar("error", ["Something went wrong!"]));
        }
      });
    console.log(event);
  };

  const handleExternalInputChange = (event: any) => {
    console.log(event);

    setItems(event.target.value);
    console.log("Id :", items);
    const paramsid = {
      programme_id: event.target.value,
    };
    DataService.getDirectData(`/coaching_request_forms`, paramsid)
      .then((res) => {
        if (res.success) {
          setLoading(true);
          console.log(res, "Copy url");
          window.sessionStorage.setItem("slug", res.coaching_request_form.slug);
          let slug = res.coaching_request_form.slug;
          setCrfSlug(slug);
        }
      })
      .catch((err) => {
        if (!err.success) {
          dispatch(showSnackbar("error", ["Something went wrong!"]));
        }
      });
    console.log(crfSlug);
  };
  const handleCoachInternalRequest = () => {
    setCrfInternalLoading(false);
  };

  const handleCoachExternalRequest = () => {
    setLoading(false);
  };
  useEffect(() => {
    const params = {
      organisation_id: orgId,
    };

    DataService.getDirectData("/programmes", params)
      .then((res) => {
        if (res?.success) {
          let data = res?.programmes;

          //service type---External
          let coachExternalName = data.filter(
            (prg: any) => prg.service_type === "external"
          );
          //service type -- Internal
          let coachInternalName = data.filter(
            (prg: any) => prg.service_type === "internal"
          );

          setCrfExternalCoach(coachExternalName);
          setCrfInternalCoach(coachInternalName);
        }
      })

      .catch((error) => {
        console.log("Something went wrong!");
      });
  }, [orgId]);

  return (
    <div>
      <Grid
        container
        direction='row'
        alignItems='center'
        justify='center'
        style={{ padding: "100px 0", textAlign: "left" }}
      >
        <Grid item xs={12} className={classes.bgImg}></Grid>
        {/* <Grid item xs={12} className={classes.bgImgOpacity}></Grid> */}
        <Grid item xs={12} className={classes.welcomeTitle}>
          <Typography
            variant='h1'
            style={{
              textAlign: "justify",
              fontWeight: "bold",
              padding: "8px 8px 16px 0px",
              fontSize: "24",
              fontFamily: "open sans",
            }}
          >
            Welcome to {orgName} Home Page
          </Typography>
          <Typography
            variant='h2'
            style={{
              textAlign: "justify",
              width: "860px",
              paddingBottom: "16px",
            }}
          >
            This is a fully functioning mock up of what a Home Page would look
            like for a real client – like yourself. Below are some programs that
            have been created around typical client needs – we will also
            demonstrate how these can be modified for all, adjusted for specific
            requirements and how new standard programs can be created.
          </Typography>
          <Typography
            variant='h2'
            style={{
              textAlign: "justify",
              width: "860px",
            }}
          >
            {" "}
            From this page it is possible to navigate to the program managers MI
            portal that tracks activity and results plus gives real time
            visibility of quantitative thematic data.
          </Typography>
          <Typography
            variant='h2'
            style={{
              textAlign: "justify",
              width: "860px",
            }}
          >
            {" "}
            <br />
            In the demonstration we will show how new assignments can be
            launched, coach panels searched and how all this can be used for
            External and Internal Coaching plus Mentoring and Assessment.
            Internal capability, availability, CPD and Supervision can also be
            tracked – please ask if this is something you are interested in.
          </Typography>
        </Grid>
        <Grid item xs={3}>
          <img
            src='../../../assets/images/aimio-logo-bannerpage.png'
            alt=''
            style={{
              height: "121px",
              position: "absolute",
              top: "75px",
              right: "46px",
            }}
          />
        </Grid>
      </Grid>

      <Grid
        container
        direction='row'
        className={classes.bgHeader}
        alignItems='center'
        justify='center'
      >
        <Grid
          item
          xs={10}
          style={{ border: "0px solid red", textAlign: "center" }}
        >
          <Grid
            container
            direction='row'
            alignItems='center'
            justify='center'
            // style={{ textAlign: "center" }}
          >
            {/* <Grid item xs={1}></Grid> */}

            {menues.map((menuData, index) => (
              <Grid
                item
                xs={2}
                key={index}
                className={
                  activeMenu === index
                    ? classes.activeMenuStyle
                    : classes.menuTitle
                }
              >
                <Typography
                  variant='h2'
                  onClick={() => setActiveMenu(index)}
                  style={{ border: "0px solid red" }}
                >
                  {menuData.menu}
                </Typography>
              </Grid>
            ))}
          </Grid>
        </Grid>
      </Grid>

      <Grid container direction='row' alignItems='center' justify='center'>
        <Grid item xs={10} style={{ marginTop: 30 }}>
          <Grid
            container
            direction='row'
            alignItems='center'
            style={{ textAlign: "center", height: "fit-content" }}
          >
            {activeMenu === 0 &&
              programes.map((data: any, index) => (
                <Grid
                  key={index}
                  item
                  xs={4}
                  justify='center'
                  style={{ padding: 10 }}
                >
                  <Card
                    variant='elevation'
                    style={{
                      padding: 20,
                      position: "relative",
                      borderWidth: 0,
                      overflow: "unset",
                      height: "18rem",
                    }}
                  >
                    <Grid container direction='row' alignItems='center'>
                      <Grid
                        item
                        xs={12}
                        justify='center'
                        className={classes.centerItem}
                      >
                        <Card className={classes.boxShadow}>
                          <img
                            style={{ height: 40 }}
                            src={index % 2 !== 0 ? icon2 : icon1}
                            alt={data.headingName}
                          />
                        </Card>
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        justify='center'
                        style={{ margin: "16px" }}
                      >
                        <Typography variant='h2' style={{ fontWeight: "bold" }}>
                          {data?.name}
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        justify='center'
                        className={classes.toolTipContainer}
                      >
                        <Typography
                          variant='h2'
                          color='textSecondary'
                          style={{
                            cursor: "pointer",
                            textAlign: "justify",
                            maxHeight: "11rem",
                            overflow: "scroll",
                          }}
                          onMouseEnter={() => setCurrentCardIndex(index)}
                          onMouseLeave={() => setCurrentCardIndex(null)}
                        >
                          {data.description}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Card>
                </Grid>
              ))}
            {activeMenu === 1 && (
              <Grid
                container
                direction='row'
                // alignItems="center"
                style={{ textAlign: "center" }}
              >
                <Grid
                  item
                  xs={4}
                  justify='center'
                  style={{ padding: 10, borderWidth: 0 }}
                >
                  <Card
                    variant='elevation'
                    style={{ padding: 20, height: "100%" }}
                  >
                    <Grid container direction='row' alignItems='center'>
                      <Grid
                        item
                        xs={12}
                        justify='center'
                        className={classes.centerItem}
                      >
                        <Card className={classes.boxShadow}>
                          <img
                            src={icon3}
                            alt='coaching request'
                            style={{ height: 40 }}
                          />
                        </Card>
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        justify='center'
                        style={{ margin: "16px" }}
                      >
                        <Typography variant='h2' style={{ fontWeight: "bold" }}>
                          External request form{" "}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} justify='center'>
                        <Typography
                          variant='h2'
                          color='textSecondary'
                          component='p'
                          style={{ textAlign: "justify" }}
                        >
                          Etiam facilisis ligula nec velit posuere egestas. Nunc
                          dictum lectus sem, vel dignissim purus luctus quis.
                          Vestibulum et ligula suscipit, hendrerit erat a,
                          ultricies velit. Praesent convallis in lorem nec
                          blandit. Phasellus a porta tellus. Suspendisse
                          sagittis metus enim. Sed molestie libero id sem
                          pulvinar, quis euismod mauris suscipit.
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        justify='center'
                        style={{ marginTop: 20 }}
                      >
                        {" "}
                        <FormControl style={{ width: "60%" }}>
                          <Select
                            variant='outlined'
                            displayEmpty
                            onChange={(event) =>
                              handleExternalInputChange(event)
                            }
                            onClose={handleCoachExternalRequest}
                          >
                            <MenuItem>
                              <Typography variant='h2'>
                                Select program
                              </Typography>
                            </MenuItem>
                            {crfExternalCoach.map((item: any) => (
                              <MenuItem value={item.id} key={item.id}>
                                <Typography variant='h2'>
                                  {item.name}
                                </Typography>
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        justify='center'
                        style={{ marginTop: 20 }}
                      >
                        <CopyToClipboard
                          text={crfSlug}
                          formName={"coaching_request_form"}
                          loading={loading}
                          setToLocal={true}
                        />
                      </Grid>
                    </Grid>
                  </Card>
                </Grid>

                <Grid item xs={4} justify='center' style={{ padding: 10 }}>
                  <Card
                    variant='elevation'
                    style={{ padding: 20, height: "100%" }}
                  >
                    <Grid container direction='row' alignItems='center'>
                      <Grid
                        item
                        xs={12}
                        justify='center'
                        className={classes.centerItem}
                      >
                        <Card className={classes.boxShadow}>
                          <img
                            src={icon3}
                            alt='coaching request'
                            style={{ height: 40 }}
                          />
                        </Card>
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        justify='center'
                        style={{ margin: "16px" }}
                      >
                        <Typography variant='h2' style={{ fontWeight: "bold" }}>
                          {" "}
                          Internal request form{" "}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} justify='center'>
                        <Typography
                          variant='h2'
                          color='textSecondary'
                          component='p'
                          style={{ textAlign: "justify" }}
                        >
                          Etiam facilisis ligula nec velit posuere egestas. Nunc
                          dictum lectus sem, vel dignissim purus luctus quis.
                          Vestibulum et ligula suscipit, hendrerit erat a,
                          ultricies velit. Praesent convallis in lorem nec
                          blandit. Phasellus a porta tellus. Suspendisse
                          sagittis metus enim. Sed molestie libero id sem
                          pulvinar, quis euismod mauris suscipit.
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        justify='center'
                        style={{ marginTop: 20 }}
                      >
                        <FormControl style={{ width: "60%" }}>
                          <Select
                            variant='outlined'
                            displayEmpty
                            onChange={(event) =>
                              handleInternalInputChange(event)
                            }
                            onClose={handleCoachInternalRequest}
                          >
                            <MenuItem>
                              <Typography variant='h2'>
                                Select program
                              </Typography>
                            </MenuItem>
                            {crfInternalCoach.map((item: any) => (
                              <MenuItem value={item.id} key={item.id}>
                                <Typography variant='h2'>
                                  {item.name}
                                </Typography>
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        justify='center'
                        style={{ marginTop: 20 }}
                      >
                        <CopyToClipboard
                          text={crfSlug}
                          formName={"coaching_request_form"}
                          loading={crfInternalLoading}
                          setToLocal={true}
                        />
                      </Grid>
                    </Grid>
                  </Card>
                </Grid>

                <Grid item xs={4} justify='center' style={{ padding: 10 }}>
                  <Card
                    variant='elevation'
                    style={{ padding: 20, height: "100%" }}
                  >
                    <Grid container direction='row' alignItems='center'>
                      <Grid
                        item
                        xs={12}
                        justify='center'
                        className={classes.centerItem}
                      >
                        <Card className={classes.boxShadow}>
                          <img
                            src={coachesIcon}
                            alt='icon'
                            style={{ height: "40px" }}
                          />
                        </Card>
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        justify='center'
                        style={{ margin: "16px" }}
                      >
                        <Typography variant='h2' style={{ fontWeight: "bold" }}>
                          {" "}
                          Request coaches
                        </Typography>
                      </Grid>
                      <Grid item xs={12} justify='center'>
                        <Typography
                          variant='h2'
                          color='textSecondary'
                          component='p'
                          style={{ textAlign: "justify" }}
                        >
                          Etiam facilisis ligula nec velit posuere egestas. Nunc
                          dictum lectus sem, vel dignissim purus luctus quis.
                          Vestibulum et ligula suscipit, hendrerit erat a,
                          ultricies velit. Praesent convallis in lorem nec
                          blandit. Phasellus a porta tellus. Suspendisse
                          sagittis metus enim. Sed molestie libero id sem
                          pulvinar, quis euismod mauris suscipit.
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        justify='center'
                        style={{ marginTop: 20 }}
                      >
                        <Button
                          disableElevation
                          variant='contained'
                          color='primary'
                          // endIcon={<ArrowForward />}
                          className={classes.btnComplete}
                          onClick={() => setRequestCoaches(true)}
                          style={{ marginTop: "60px" }}
                        >
                          Coach request
                        </Button>
                      </Grid>
                    </Grid>
                  </Card>
                </Grid>
              </Grid>
            )}
            {activeMenu === 2 &&
              resourceList.map((e: any, i) => (
                <Grid
                  key={i}
                  container
                  direction='row'
                  alignItems='center'
                  style={{
                    textAlign: "center",
                    padding: 15,
                    borderBottom: "1px solid #ece6e6",
                  }}
                >
                  <Grid
                    item
                    xs={1}
                    justify='center'
                    className={classes.centerItem}
                  >
                    {" "}
                  </Grid>
                  <Grid
                    item
                    xs={3}
                    justify='center'
                    className={classes.centerItem}
                  >
                    <Card className={classes.boxShadow}>
                      <img
                        src={e.src}
                        alt={e.HeadingTitle}
                        style={{ height: 40 }}
                      />
                    </Card>
                  </Grid>
                  <Grid item xs={4} style={{ textAlign: "left" }}>
                    <Typography variant='h2' style={{ fontWeight: "bold" }}>
                      {e.HeadingTitle}
                    </Typography>
                  </Grid>
                  <Grid item xs={2}>
                    {e.HeadingTitle === "Coaching needs assessment" ? (
                      <a
                        href='https://drive.google.com/file/d/1HLbI-_UDART54zL23NyXq0ngckX4QcKm/view?usp=sharing'
                        target='_blank'
                        style={{ textDecorationLine: "none" }}
                      >
                        <Button
                          disableElevation
                          variant='contained'
                          color='primary'
                          // endIcon={<ArrowForward />}
                          className={classes.btnComplete}

                          // style={{ marginLeft: "-82px" }}
                          // onClick={()=>handlepdfviewer()}
                        >
                          Read more
                        </Button>
                      </a>
                    ) : (
                      ""
                    )}

                    {e.HeadingTitle === "The benefits of coaching" ? (
                      <a
                        href='https://drive.google.com/file/d/1O-ctjBg9tkW1FciX-LVivzicAdbMy1sG/view?usp=sharing '
                        target='_blank'
                        style={{ textDecorationLine: "none" }}
                      >
                        <Button
                          disableElevation
                          variant='contained'
                          color='primary'
                          // endIcon={<ArrowForward />}
                          className={classes.btnComplete}
                          // style={{ marginLeft: "-82px" }}
                          // onClick={()=>handlepdfviewer()}
                        >
                          Read more
                        </Button>
                      </a>
                    ) : (
                      ""
                    )}

                    {e.HeadingTitle ===
                    "Executive coaching diagnostic checklist" ? (
                      <a
                        href='https://drive.google.com/file/d/1SOuCoLsGZwQPbZG2V3EpFoT69YlT4uh9/view?usp=sharing'
                        target='_blank'
                        style={{ textDecorationLine: "none" }}
                      >
                        <Button
                          disableElevation
                          variant='contained'
                          color='primary'
                          // endIcon={<ArrowForward />}
                          className={classes.btnComplete}
                          // style={{ marginLeft: "-82px" }}
                          // onClick={()=>handlepdfviewer()}
                        >
                          Read more
                        </Button>
                      </a>
                    ) : (
                      ""
                    )}
                    {e.HeadingTitle === "Is coaching right for you" ? (
                      <a
                        href='https://drive.google.com/file/d/13Cdzw0_oOpe1FQrRFQwA8jYJhyvfZC6m/view?usp=sharing'
                        target='_blank'
                        style={{ textDecorationLine: "none" }}
                      >
                        <Button
                          disableElevation
                          variant='contained'
                          color='primary'
                          // endIcon={<ArrowForward />}
                          className={classes.btnComplete}
                          // style={{ marginLeft: "-82px" }}
                          // onClick={()=>handlepdfviewer()}
                        >
                          Read more
                        </Button>
                      </a>
                    ) : (
                      ""
                    )}

                    {e.HeadingTitle ===
                    " How to get the best from your coaching" ? (
                      <a
                        href='https://drive.google.com/file/d/1h1DvoRjsQbDTaAsdRBrOaQHWfnTeYkCc/view?usp=sharing'
                        target='_blank'
                        style={{ textDecorationLine: "none" }}
                      >
                        <Button
                          disableElevation
                          variant='contained'
                          color='primary'
                          // endIcon={<ArrowForward />}
                          className={classes.btnComplete}
                          // style={{ marginLeft: "-82px" }}
                          // onClick={()=>handlepdfviewer()}
                        >
                          Read more
                        </Button>
                      </a>
                    ) : (
                      ""
                    )}
                  </Grid>
                </Grid>
              ))}

            {activeMenu === 3 &&
              coachPannel.map((e: any) => (
                <Grid item xs={4} justify='center' style={{ padding: 10 }}>
                  <Card
                    variant='elevation'
                    style={{
                      padding: 20,
                      borderWidth: 0,
                      height: "44em",
                      maxWidth: "auto",
                    }}
                  >
                    <Grid container direction='row' alignItems='center'>
                      <Grid
                        item
                        xs={12}
                        justify='center'
                        className={classes.centerItem}
                      >
                        <Card className={classes.boxShadow}>
                          {/* <ContactPhoneOutlined style={{ fontSize: 40 }} /> */}
                          {e.headingtitle === "External panel" ? (
                            <img
                              src={externalIcon}
                              alt='icon'
                              style={{ height: "40px" }}
                            />
                          ) : (
                            ""
                          )}
                          {e.headingtitle === "Internal panel" ? (
                            <img
                              src={coachesIcon}
                              alt='icon'
                              style={{ height: "40px" }}
                            />
                          ) : (
                            ""
                          )}
                          {e.headingtitle === "Onboard coach request" ? (
                            <img
                              src={onboardIcon}
                              alt='icon'
                              style={{ height: "40px" }}
                            />
                          ) : (
                            ""
                          )}
                        </Card>
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        justify='center'
                        style={{ margin: "16px" }}
                      >
                        <Typography variant='h2' style={{ fontWeight: "bold" }}>
                          {e.headingtitle}
                        </Typography>
                      </Grid>
                      {e.headingtitle === "Onboard coach request" ? (
                        <>
                          <Grid
                            item
                            xs={12}
                            justify='center'
                            alignItems='flex-start'
                            style={{
                              textAlign: "justify",
                              whiteSpace: "pre-wrap",
                              wordSpacing: "1px",
                            }}
                          >
                            <Typography
                              display='block'
                              variant='h2'
                              color='textSecondary'
                            >
                              We are able to onboard additional coaches where
                              supported by the client and where there is a clear
                              justification, for example:
                              <ul className={classes.textList}>
                                {" "}
                                <li>
                                  Coachee worked with a particular coach
                                  previously
                                </li>
                                <li>
                                  Coach has unusual levels of a particular
                                  capability that is underrepresented in the
                                  panel
                                </li>
                                <li>
                                  A senior sponsor recommends a particular coach{" "}
                                </li>
                              </ul>
                              Sometimes there is a need for additional
                              capability to be added to the panel where
                              stakeholders don’t have a particular coach in
                              mind.In these cases, aimio offers you scope to
                              capture your needs and preferences or set up a
                              call to discuss and identify alternative coaches
                              from the wider pool that can deliver the required
                              capability.
                              <br />
                              <br />
                              <br />
                            </Typography>
                          </Grid>
                          <LightTooltip
                            title={
                              <Typography variant='h2'>
                                Can’t find what you’re looking for? Click here
                              </Typography>
                            }
                          >
                            <Grid item xs={12} style={{ marginTop: 45 }}>
                              <Button
                                disableElevation
                                variant='contained'
                                color='primary'
                                // endIcon={<ArrowForward />}
                                className={classes.btnOnboardCoach}
                                onClick={() => setRequestOnBoardCoaches(true)}
                                style={{
                                  top: "-35px",
                                  position: "relative",
                                  width: "23em",
                                  marginLeft: "0px",
                                }}
                              >
                                Onboard coach
                              </Button>
                              <Button
                                disableElevation
                                variant='contained'
                                color='primary'
                                // endIcon={<ArrowForward />}
                                className={classes.btnOnboardCoach}
                                style={{ marginTop: "-24px" }}
                                onClick={() => setRequestforassistance(true)}
                              >
                                Request for assistance/Alternative coaches
                              </Button>{" "}
                              <br />{" "}
                            </Grid>
                          </LightTooltip>
                        </>
                      ) : (
                        <>
                          <Grid
                            item
                            xs={12}
                            justify='center'
                            alignItems='flex-start'
                            style={{
                              textAlign: "justify",
                              whiteSpace: "pre-wrap",
                              wordSpacing: "1px",
                            }}
                          >
                            <Typography
                              display='block'
                              variant='h2'
                              color='textSecondary'
                              component='p'
                            >
                              {e.info}
                            </Typography>
                          </Grid>
                          <Grid
                            item
                            xs={12}
                            justify='center'
                            style={{ marginTop: 122 }}
                          >
                            <Button
                              disableElevation
                              variant='contained'
                              color='primary'
                              // endIcon={<ArrowForward />}
                              className={classes.btnComplete}
                              style={{ marginTop: "-126px" }}
                              onClick={() => {
                                history.push(e.route);
                              }}
                            >
                              View panel
                            </Button>{" "}
                            <br />
                          </Grid>{" "}
                        </>
                      )}
                    </Grid>
                  </Card>
                </Grid>
              ))}
            {activeMenu === 4 && (
              <Grid
                container
                direction='row'
                alignItems='center'
                justify='center'
                style={{ borderRadius: "5px" }}
                spacing={4}
              >
                <Grid item xs={3} justify='center'>
                  <Grid
                    container
                    direction='row'
                    className={classes.cardColor}
                    alignItems='center'
                  >
                    <Grid
                      item
                      xs={12}
                      justify='center'
                      className={classes.centerItem}
                    >
                      <Card className={classes.boxShadow}>
                        <img
                          src={icon5}
                          alt='icon'
                          style={{ height: "40px" }}
                        />
                      </Card>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      justify='center'
                      style={{ margin: "25px" }}
                    >
                      <Typography variant='h2'>
                        To discuss new program
                      </Typography>
                    </Grid>
                    <Grid item xs={12} justify='center'>
                      <Button
                        disableElevation
                        variant='contained'
                        color='primary'
                        className={classes.btnComplete}
                        onClick={() => setProgramRequest(true)}
                      >
                        Complete form
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid
                  item
                  xs={7}
                  container
                  justify='center'
                  alignItems='center'
                  style={{ backgroundColor: "#EEEEEE" }}
                >
                  <Grid
                    container
                    direction='row'
                    alignItems='center'
                    justify='center'
                    style={{ textAlign: "center", padding: "34px" }}
                  >
                    <Grid
                      item
                      xs={12}
                      justify='center'
                      style={{ marginBottom: 30 }}
                    >
                      <Typography
                        variant='subtitle1'
                        style={{ fontWeight: 700 }}
                      >
                        Our dedicated team is here to support you. Please
                        contact us or request a call:
                      </Typography>
                    </Grid>
                    <br />
                    <Grid item xs={12} container justify='center'>
                      <div style={{ width: "fit-content", textAlign: "left" }}>
                        <Typography
                          variant='h2'
                          color='textSecondary'
                          component='p'
                        >
                          Telephone: +44 (0) 207 1000 121
                        </Typography>
                        {/* </Grid>
                    <Grid item xs={12} justify="center"> */}
                        <Typography
                          variant='h2'
                          color='textSecondary'
                          component='p'
                        >
                          Email: coaches@acuitycoaching.com
                        </Typography>
                      </div>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            )}
          </Grid>
        </Grid>

        {activeMenu === 0 && (
          <Grid
            container
            justify='flex-end'
            xs={10}
            style={{ marginTop: "32px" }}
          >
            {page > 1 && (
              <Button
                variant='outlined'
                color='primary'
                style={{ marginRight: "16px", textTransform: "none" }}
                startIcon={<NavigateBeforeIcon />}
                onClick={() => setPage((prevState) => prevState - 1)}
              >
                Back
              </Button>
            )}
            {COUNT_PER_PAGE < totalCount && !isLastPage && (
              <Button
                variant='outlined'
                color='primary'
                endIcon={<NavigateNextIcon />}
                onClick={() => setPage((prevState) => prevState + 1)}
                style={{ textTransform: "none", marginRight: "13px" }}
              >
                More
              </Button>
            )}
          </Grid>
        )}
      </Grid>

      <Grid container direction='row' alignItems='center' justify='center'>
        <Grid item xs={10} style={{ marginTop: 30, marginBottom: 26 }}>
          <Grid container direction='row' alignItems='center' justify='center'>
            <Grid item xs={7} style={{ marginTop: 30 }}>
              <Typography
                variant='h6'
                style={{ color: "#575756" }}
              ></Typography>
              <img style={{ height: "56px" }} src={""} alt='' />
            </Grid>
            <Grid
              item
              xs={5}
              justify='flex-end'
              style={{
                marginTop: 30,
                justifyContent: "flex-end",
                display: "flex",
                alignItems: "center",
              }}
            >
              <Button
                disableElevation
                variant='outlined'
                color='primary'
                className={classes.btnCall}
                style={{ marginRight: "16px" }}
                onClick={handleOpen}
                startIcon={
                  <img
                    style={{ height: "20px" }}
                    src={phoneIcon}
                    alt='request-a-call-icon'
                  />
                }
              >
                Call request
              </Button>
              <Button
                disableElevation
                variant='outlined'
                color='primary'
                className={classes.btnCall}
                onClick={() => setRequestCoaches(true)}
                startIcon={
                  <img
                    style={{ height: "20px" }}
                    src={coachesIcon}
                    alt='request-a-call-icon'
                  />
                }
              >
                Coach request
              </Button>
              <ShotcutPopup
                open={isShotcutPopupOpen}
                handleOpen={() => setIsShotcutPopupOpen(true)}
                handleClose={() => setIsShotcutPopupOpen(false)}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid>
        <Footer />
      </Grid>
      {requestCallFlag && (
        <RequestCall
          isRequesting={busy === "requesting"}
          title='Call request'
          handleClose={handleClose}
          submitHandler={requestCoachHandler}
          errors={fieldsError}
          setErrors={setFieldsError}
          isThanksPopupOpen={isThanksPopupOpen}
          closeThanksPopup={() => setIsThanksPopupOpen(false)}
        />
      )}
      {requestCoaches && (
        <RequestCall
          isRequesting={busy === "requesting"}
          title=' Coach request '
          handleClose={() => setRequestCoaches(false)}
          submitHandler={requestCoachHandler}
          errors={fieldsError}
          setErrors={setFieldsError}
        />
      )}

      {isThanksPopupOpen && (
        <ThanksPopup
          open={isThanksPopupOpen}
          closeHandler={() => setIsThanksPopupOpen(false)}
        />
      )}

      {requestOnBoardCoaches && (
        <OnboardCoachDetails
          isRequesting={busy === "requesting"}
          title='Onboard coach'
          handleClose={() => setRequestOnBoardCoaches(false)}
          submitHandler={requestCoachHandler}
          errors={fieldsError}
          setErrors={setFieldsError}
        />
      )}
      {requestforassistance && (
        <Requestforassistance
          isRequesting={busy === "requesting"}
          title='Request for assistance'
          handleClose={() => setRequestforassistance(false)}
          submitHandler={requestCoachHandler}
          errors={fieldsError}
          setErrors={setFieldsError}
        />
      )}
      {programRequest && (
        <Requestforassistance
          isRequesting={busy === "requesting"}
          title='Program request'
          handleClose={() => setProgramRequest(false)}
          submitHandler={requestCoachHandler}
          errors={fieldsError}
          setErrors={setFieldsError}
        />
      )}
    </div>
  );
}

export default Home;

const useStyles = makeStyles({
  infoCard: {
    border: "1px solid #ccc",
    position: "absolute",
    zIndex: 9,
    backgroundColor: "#fff",
    borderRadius: 5,
    margin: "19px",
    top: "60px",
  },
  bgImg: {
    backgroundImage: "url(../../../assets/images/landingpage_banner.png)",
    backgroundRepeat: "noRepeat",
    height: "18rem",
    position: "absolute",
    top: "64px",
    bottom: 0,
    width: "100%",
    backgroundSize: "cover",
    zIndex: -2,
  },
  bgImgOpacity: {
    // border: "0px solid red",
    //background: "linear-gradient(90deg, rgba(0,121,107,1) 20%, rgba(0,77,64,1) 38%)",
    // background:" linear-gradient(to right, #007475, #005660)",
    // backgroundImage: "url(../../../assets/images/aimio-logo-bannerpage.png)",
    // height: "100%",
    position: "absolute",
    top: 0,
    bottom: 0,
    width: "50px",
    zIndex: -1,
    opacity: ".8",
  },
  welcomeTitle: {
    color: "#fff",
    // position: "relative",
    marginLeft: "59px",
    marginTop: "-85px",
  },
  textContent: {
    color: "#fff",
    lineHeight: 2.5,
    // position: "relative",
    // marginLeft: "-101px",
    marginTop: " -30px",
  },

  bgHeader: {
    backgroundColor: "#e9f1f1",
    // padding: 10,
    marginTop: "3px",
  },
  menuTitle: {
    padding: 20,
    color: "#003232",
  },
  activeMenuStyle: {
    backgroundColor: "#EF7000",
    padding: 20,
    color: "#fff",
  },

  centerImg: {
    border: "0px solid yellow",
    width: "100%",
    justifyContent: "center",
    textAlign: "center",
    display: "flex",
  },
  boxShadow: {
    border: "0px solid red",
    width: 50,
    height: 40,
    padding: 10,
  },
  centerItem: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    border: "0px solid red",
  },

  btnComplete: {
    backgroundColor: "#EF7000",
    //  color:"rgb(30,30,30)",
    textTransform: "none",
    fontSize: 12,
    // float:"right",
    "&:hover": {
      background: "#EF7000",
      color: "#FFF",
    },
  },
  btnOnboardCoach: {
    backgroundColor: "#EF7000",
    textTransform: "none",
    // float:"right",
    "&:hover": {
      background: "#EF7000",
      color: "#FFF",
    },
  },
  btnCall: {
    textTransform: "none",
    borderRadius: "30px",
    color: "#077F83",
    borderColor: "#077F83",
    fontWeight: 500,
    height: 53,
    width: 203,
    "&:hover": {
      borderColor: "#077F83",
    },
  },

  btnShare: {
    backgroundColor: "#fff",
    border: "1px solid #077F83",
    textTransform: "capitalize",
    color: "#077F83",
  },
  cardColor: {
    backgroundColor: "#EEEEEE",
    padding: 20,
    textAlign: "center",
    marginTop: 30,
    marginBottom: 30,
    borderRadius: 5,
  },
  textList: {
    marginLeft: 5,
    marginTop: -13,
    marginBottom: 0,
  },
  toolTipContainer: {
    ".MuiTooltip-tooltipPlacementTop": {
      //   top: "-113px",
      position: "relative",
    },
  },
});
